import React from "react";
import { render } from "react-dom";
import AppContainer from "./containers/AppContainer";
import "./css/main.css";

render(<AppContainer />, document.getElementById("root"));
